<script>
//本地环境
// const imgPath = "http://192.168.1.51:8098/CMGPT/"; //图像路径
// const axiosDefaultsURL = "http://192.168.1.51:8098/CMGPT"; //服务端地址

// const imgPath = "http://192.168.1.150:8098/CMGPT/"; //图像路径
// const axiosDefaultsURL = "http://192.168.1.150:8098/CMGPT"; //服务端地址

//刘总本地环境
// const imgPath = "http://192.168.1.245:8098/CMGPT/"; //图像路径
// const axiosDefaultsURL = "http://192.168.1.245:8098/CMGPT"; //服务端地址

//线上环境
const imgPath = "http://112.124.34.251:8098/CMGPT"; //图像路径
const axiosDefaultsURL = "http://112.124.34.251:8098/CMGPT"; //服务端地址
export default {
  imgPath,
  axiosDefaultsURL,
};
</script>
